export var MARKET_US = {
    'site': {
        'meServer': 'https://dev.mynuskin.com',
        'legacyServer': 'https://dev.nuskin.com',

        // search-distributor page
        // sign-in page
        'signInForgotPasswordPagePath': '#forgot-password',
        'forgotUserNamePath': '#forgot-username',
        'passwordShowImage': 'https://dev.mynuskin.com/etc/clientlibs/mecommerce/core/main/css/src/assets/images/css/ic-password-show.png',
        'passwordHideImage': 'https://dev.mynuskin.com/etc/clientlibs/mecommerce/core/main/css/src/assets/images/css/ic-password-hide.png',
        // pages in other modules
        'signInAccLinkingPagePath': '', // where do we set this url ?

        'loggedInRedirectionPagePath': '',

        // forgot password
        'forgotPasswordEmailTemplatePath': 'https://www.mynuskin.com/content/mecommerce/americas/US/en/email-templates/reset-password.html',

        'dateMask': 'L',

        'countryCode': 'US',
        'languages': ['en', 'es'],
        'countries': ['US', 'CA', 'UK', 'FR'],
        'otherOptionHide': false,
        'hideDirectDeposit': false,

        // Account Tax ID
        'hasBusinessTaxIdTooltip': false,
        'businessTaxIdMaxLength': '',
        
        /* config properties -
         Hardcoded for now, but these properties will come from a service
         */
        'countryName': 'USA',
        'isBussDistEnabled': true,
        'isOpted': 'true',
        'minAge': '18',
        // "everyOneOption": true,
        // "familyOption": true,
        // "spannerLocatorOption": true,
        // "sposoredSearchOption": true,
        // "uplineOption": true,

        'enableEveryOneOption': true,
        'enableFamilyOption': true,
        'enableSponsorOption': true,
        'enableUplineOption': true,
        'enableScannerOption': true,
        'hasDirectDepositPolicy': true,
        'enableFamilySection': false,

        // termsandconditions page
        'TandCversionNumber': '20170818',
        'distributorCompensationPath': '/content/dam/mecommerce/termsandconditions',
        'productPolicyPath': '/content/dam/mecommerce/termsandconditions',
        'termsandconditionscontentpath': '/content/dam/mecommerce/termsandconditions',
    },

    'system': {
        'apiKey': '3_NTZni05Zl9uceYz1PzCl7FIGpVU7868vRdEU75mhNxSJBVZYRbHEMMTJzpFA7TeQ',
        'atlas_service_url': 'https://test.nuskin.com/eft-service/api/v2/',
        'googleApiKey': 'AIzaSyBYw4aJ-Fw7JWFNiiZJAkBl91dPXlvgC3I',
        'googlePlacesApiServerKey': 'AIzaSyBYw4aJ-Fw7JWFNiiZJAkBl91dPXlvgC3I',
        'googlePlacesOnOffFlag': false,
        'mulesoft.client_id': '764567a95afb4caba4944cf6f688886c',
        'mulesoft.client_secret': 'ca00cddaebd14e418041998B7F3F3787',
        'mulesoft.hybris_endpoint': 'https://devgw.mynuskin.com/mec/api/',
        'mulesoft.hybris_guest_endpoint': 'https://devgw.mynuskin.com/token/api/',
        'mulesoft.solr_endpoint': 'https://devgw.mynuskin.com/mec/solr/',
        'mulesoft.storefront_endpoint': 'https://devgw.mynuskin.com/mec/sf/',
        'mulesoft.token_endpoint': 'https://devgw.mynuskin.com/token/api/',
        'nsjs.service.endpoint': 'https://dev.nuskin.com/js/nsjsmec/dist',
        'qas_service_url': 'https://dev.nuskin.com/signupApp/qas/prowebproxy.jsp',
        's3_bucket_url': 'https://mecommerce-dev.s3.amazonaws.com',
        'sapServiceEndPoint': 'https://dev.nuskin.com',
        'secret': 'kUCVli9FfHK6V6w8QD59zQo9DOSg84Mc',
        'userKey': 'AK264VisvLpJ'
    },

    'languageCode': 'en' // This will be injected in the wrapper
};



//////////////////
// WEBPACK FOOTER
// ./data/configs.us.js
// module id = 363
// module chunks = 0